import { render, staticRenderFns } from "./AppointmentFollowupWithTodo.vue?vue&type=template&id=381d7c37"
import script from "./AppointmentFollowupWithTodo.vue?vue&type=script&lang=ts"
export * from "./AppointmentFollowupWithTodo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports